const keys = ["C","C#","D","D#","E","F","F#","G","G#","A","A#","B"];

export default keys;